module.exports = __webpack_public_path__ + "img/forage2.01916f8d.png";